export const CLASS_NAME = 'cst-insights-side-bar'
export const SPLIT_WIDTH = 855
export const WIDTH = 500
